import React, { Fragment, useMemo, useState } from "react";
import { useErrorHandler } from "../../../../hooks";
import glassesService from "../../../../services/glasses.service";
import { useSelector } from "react-redux";
import { Button, DialogActions, DialogContent, Divider, Grid, IconButton, Typography } from "@material-ui/core";
import DialogTitle from "../../../../components/dialog-title";
import { DeleteOutline } from "@material-ui/icons";


const FormWrapper = ({ children }) => (
    <DialogContent>
        <Grid container spacing={2}>
            {children}
        </Grid>
    </DialogContent>
);

export default function GlassGalleryForm({ close, data, extra }) {
    const [deletedFile, setDeletedFile] = useState([]);
    const [imgUrl, setImageUrl] = useState(data?.images?.map(url => ({isNew: false, url })) ?? []);
    const [imgFiles, setImageFile] = useState([]);

    const errorHandler = useErrorHandler();

    const handleSubmit = async () => {
        let op = await glassesService.uploadGlassImg(data.id, { 
            images: imgFiles.map(item => item.file), 
            deletedFile: deletedFile 
        });
        const { error } = op;
        if (error) return errorHandler(error);

        close(true);
    };

    const imgFilehandler = (e) => {
        if (e.target.files.length !== 0) {
            let id = Math.floor(Math.random() * 1000000);
            setImageUrl(imgUrl => [...imgUrl, {id, isNew: true, url: URL.createObjectURL(e.target.files[0])}])
            setImageFile(imgUrl => [...imgUrl, {id, file: e.target.files[0]}])
        }
    }

    const imgDeleteHandler = (url) => {
        const index = imgUrl.findIndex(it => it.url === url);
        if(!imgUrl[index].isNew){
            setDeletedFile(prev => ([...prev, url]));
            setImageUrl(prev => {
                prev.splice(index, 1);
                return [...prev]
            })
        }
        else{
            const indexOfFile = imgFiles.findIndex(it => it.id === imgUrl[index].id);
            setImageFile(prev => {
                prev.splice(indexOfFile, 1);
                return [...prev]
            })
            setImageUrl(prev => {
                prev.splice(index, 1);
                return [...prev]
            })
        }
    }

    return (
        <>
            <DialogTitle onClose={close}>
                گالری عکس
            </DialogTitle>
            <Divider />
            <div className="m-2">
                <input type="file" accept="image/*" value={null} onChange={imgFilehandler} />
            </div>
            <div className="m-2 d-flex justify-content-center" style={{gap: "13px", flexWrap: "wrap"}}>
                {imgUrl.map((elem) => {
                    return <>
                        <span className="previewImg" key={elem.url} onClick={() => imgDeleteHandler(elem.url)}>
                            <img src={elem.url} alt="med1" />
                            <div className="remove">
                                <DeleteOutline fontSize={"large"}/>
                            </div>
                        </span>
                    </>
                })}
            </div>
            <DialogActions>
                <Button onClick={close} color="primary">
                    لغو
                </Button>
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                >
                    ذخیره
                </Button>
            </DialogActions>
        </>
    )
}
